"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiDrawerThemeOptions = void 0;
exports.MuiDrawerThemeOptions = {
    styleOverrides: {
        root: {
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
        },
        paper: {
            display: "flex",
            flexDirection: "column",
        },
    },
};
